module.exports = __webpack_public_path__ + "img/G_Art_Claw_R_1_3_4.a4ea56b5.png";